/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackSegment
 */
export interface TrackSegment {
    /**
     * 
     * @type {number}
     * @memberof TrackSegment
     */
    duration: number;
    /**
     * 
     * @type {string}
     * @memberof TrackSegment
     */
    multihash: string;
}

/**
 * Check if a given object implements the TrackSegment interface.
 */
export function instanceOfTrackSegment(value: object): value is TrackSegment {
    let isInstance = true;
    isInstance = isInstance && "duration" in value && value["duration"] !== undefined;
    isInstance = isInstance && "multihash" in value && value["multihash"] !== undefined;

    return isInstance;
}

export function TrackSegmentFromJSON(json: any): TrackSegment {
    return TrackSegmentFromJSONTyped(json, false);
}

export function TrackSegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackSegment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'duration': json['duration'],
        'multihash': json['multihash'],
    };
}

export function TrackSegmentToJSON(value?: TrackSegment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'duration': value.duration,
        'multihash': value.multihash,
    };
}

